import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { MAPPING_TYPE } from "Pages/User/CustomMapping/@constants"
import { acrissTable, categoriesTable, selectedMappingId, setMappingFormData } from "Pages/User/CustomMapping/@signals"
import { useToast } from "@hooks"
import { useSignal } from "@preact/signals-react"

export default function useCustomMappingUpdate() {

	const { showToast } = useToast()
	const isLoadingDelete = useSignal(false)

	const handleDeleteMapping = useCallback((idCustom, path) => {
		showToast.confirm(`Are you sure to delete this mapping?`, {
			onSubmit: () => {
				isLoadingDelete.value = true
				showToast.promise(postSubmit(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/disable`,
					{ idCustom: idCustom }),
				).then(() => {
					if (path === MAPPING_TYPE.ACRISS) {
						acrissTable.value = [...acrissTable.value?.filter(e => idCustom !== e.idCustom)]
					} else {
						categoriesTable.value = [...categoriesTable.value?.filter(e => idCustom !== e.idCustom)]
					}
				}).catch(() => {
					showToast.error()
				}).finally(() => {
					isLoadingDelete.value = false
				})
			}
		})
	}, [])

	const handleEditMapping = useCallback((idCustom, path) => {
		selectedMappingId.value = idCustom
		setMappingFormData(path, 'edit')
	}, [])


	return {
		handleDeleteMapping,
		handleEditMapping,
		isLoadingDelete: isLoadingDelete.value
	}
}